import {prestationsConstants, typologieLavageConstants} from './prestations.constants.js';
import {authenticationConstants} from "../authentication/auth.constants";

const initialState = {
    prestations: null,
    prestation: null,
    typologiesLavage: null,
    typologieLavage: null,
    loading: false,
    error: null
}

export function prestations(state = initialState, action) {
    switch (action.type) {
        // --- PRESTATIONS ---
        case prestationsConstants.PRESTATIONS_FETCH_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case prestationsConstants.PRESTATIONS_FETCH_SUCCESS:
            return {
                ...state,
                prestations: action.prestations,
                prestation: null,
                loading: false,
                error: null
            };
        case prestationsConstants.PRESTATIONS_FETCH_ONE_REQUEST:
            return {
                ...state,
                prestation: null,
                loading: true,
                error: null
            };
        case prestationsConstants.PRESTATIONS_FETCH_ONE_SUCCESS:
            return {
                ...state,
                prestation: action.prestation,
                prestations: null,
                loading: false,
                error: null
            };
        case prestationsConstants.PRESTATIONS_FETCH_ONE_FAILURE:
            return {
                ...state,
                prestation: null,
                loading: false,
                error: action.error
            };
        case prestationsConstants.PRESTATIONS_DELETE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case prestationsConstants.PRESTATIONS_DELETE_SUCCESS:
        case prestationsConstants.PRESTATIONS_CREATE_SUCCESS:
        case prestationsConstants.PRESTATIONS_UPDATE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                prestations: null,
                prestation: null
            };
        case prestationsConstants.PRESTATIONS_FETCH_FAILURE:
        case prestationsConstants.PRESTATIONS_CREATE_FAILURE:
        case prestationsConstants.PRESTATIONS_UPDATE_FAILURE:
        case prestationsConstants.PRESTATIONS_DELETE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        case prestationsConstants.PRESTATIONS_CLEAR_REQUEST:
            return {
                ...initialState
            }
        // --- TYPOLOGIES LAVAGE ---
        case typologieLavageConstants.TYPOLOGIES_LAVAGE_FETCH_REQUEST:
        case typologieLavageConstants.TYPOLOGIES_LAVAGE_FETCH_ONE_REQUEST:
        case typologieLavageConstants.TYPOLOGIES_LAVAGE_CREATE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case typologieLavageConstants.TYPOLOGIES_LAVAGE_FETCH_SUCCESS:
            return {
                ...state,
                typologiesLavage: action.payload,
                typologieLavage: null,
                loading: false,
                error: null
            };

        case typologieLavageConstants.TYPOLOGIES_LAVAGE_FETCH_ONE_SUCCESS:
            return {
                ...state,
                typologieLavage: action.payload,
                typologiesLavage: null,
                loading: false,
                error: null
            };

        case typologieLavageConstants.TYPOLOGIES_LAVAGE_CREATE_SUCCESS:
            return {
                ...state,
                typologiesLavage: null,
                loading: false,
                error: null
            };

        case typologieLavageConstants.TYPOLOGIES_LAVAGE_FETCH_FAILURE:
        case typologieLavageConstants.TYPOLOGIES_LAVAGE_FETCH_ONE_FAILURE:
        case typologieLavageConstants.TYPOLOGIES_LAVAGE_CREATE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        case typologieLavageConstants.TYPOLOGIES_LAVAGE_CLEAR:
            return {
                ...state,
                typologiesLavage: null,
                typologieLavage: null
            };

        // --- LOGOUT ---
        case authenticationConstants.LOGOUT:
            return {
                initialState
            }
        default:
            return state
    }
}
